import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { ArrowUpRight, ChevronLeft, ChevronRight } from "lucide-react"
import "./HeroSection.css"

const heroSlides = [
  {
    src: "/images/hero-riyadh-sunset.png",
    mobileSrc: "/images/hero-mobile-riyadh-sunset.png",
    alt: "Highway to Riyadh at sunset with reflective road markers",
  },
  {
    src: "/images/hero-city-skyline.png",
    mobileSrc: "/images/hero-mobile-city-skyline.png",
    alt: "Driving toward a city skyline at sunset",
  },
]

export function HeroSection() {
  const { t, i18n } = useTranslation()
  const isArabic = i18n.resolvedLanguage === "ar"
  const [activeSlide, setActiveSlide] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % heroSlides.length)
    }, 6000)
    return () => clearInterval(timer)
  }, [])

  const goToPrev = () => {
    setActiveSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)
  }

  const goToNext = () => {
    setActiveSlide((prev) => (prev + 1) % heroSlides.length)
  }

  return (
    <section id="home" className="hero">
      {/* Background image slides */}
      {heroSlides.map((slide, index) => (
        <picture
          key={slide.src}
          className={`hero__bg ${index === activeSlide ? "hero__bg--active" : ""}`}
        >
          <source media="(max-width: 1023px)" srcSet={slide.mobileSrc} />
          <img src={slide.src} alt={slide.alt} />
        </picture>
      ))}
      {/* Overlays for text legibility */}
      <div className="hero__overlay-1" />
      <div className="hero__overlay-2" />

      {/* Content */}
      <div className="hero__content">
        <div className="hero__inner">
          <span className="hero__badge">{t("Road Safety Equipment Supplier")}</span>
          <h1 className="hero__title">{t("Reflective safety you can rely on")}</h1>
          <p className="hero__text">
            {t("Road's Reflectors supplies and installs a complete range of road safety products — reflective sheeting, road markers, crash cushions, solar studs and more — sourced from leading global manufacturers.")}
          </p>

          <div className="hero__actions">
            <a href="#products" className="btn-pill btn-pill--brand btn-pill--lg">
              {t("Explore Products")}
              <span className="btn-pill__arrow">
                <ArrowUpRight size={14} />
              </span>
            </a>
            <a
              href="/RoadsReflectorsprofile.pdf"
              download="RoadsReflectorsprofile.pdf"
              className="hero__cta-profile btn-pill btn-pill--yellow btn-pill--lg"
            >
              {t("View Company Profile")}
              <span className="btn-pill__arrow">
                <ArrowUpRight size={14} />
              </span>
            </a>
          </div>

          {/* Slide navigation arrows — normal flow below the CTAs on mobile,
              pinned to the bottom-right corner on larger screens (see CSS) */}
          <div className="hero__nav">
            <button
              type="button"
              onClick={goToPrev}
              aria-label={t("Previous slide")}
              className="hero__nav-btn"
            >
              {isArabic ? <ChevronRight size={22} /> : <ChevronLeft size={22} />}
            </button>
            <button
              type="button"
              onClick={goToNext}
              aria-label={t("Next slide")}
              className="hero__nav-btn"
            >
              {isArabic ? <ChevronLeft size={22} /> : <ChevronRight size={22} />}
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}